import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { copy, Copy } from './copy';
import { Lang } from './types';
const STORAGE_KEY = 'gbs-language';
function detectInitialLang(): Lang {
  if (typeof window === 'undefined') {
    return 'es';
  }
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === 'es' || stored === 'en') {
    return stored;
  }
  const browserLang = window.navigator.language?.toLowerCase() ?? '';
  return browserLang.startsWith('es') ? 'es' : 'en';
}
interface LanguageContextValue {
  lang: Lang;
  setLang: (next: Lang) => void;
  toggleLang: () => void;
  t: Copy;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>(detectInitialLang);
  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);
  const setLang = useCallback((next: Lang) => setLangState(next), []);
  const toggleLang = useCallback(() => setLangState(current => current === 'es' ? 'en' : 'es'), []);
  const value = useMemo(() => ({
    lang,
    setLang,
    toggleLang,
    t: copy[lang]
  }), [lang, setLang, toggleLang]);
  return <LanguageContext.Provider value={value} data-id="element-242" data-mp="2pir50hqep44g">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}